import { IBillEmail } from "./billEmail.types"

export class BillEmail implements IBillEmail {
  id: number
  deliveryStatus: string

  constructor(id: number, deliveryStatus: string) {
    this.id = id
    this.deliveryStatus = deliveryStatus
  }
}
